import type { Product } from "../types";
import { baseApi } from "./base";

export const productApi = baseApi.injectEndpoints({
  endpoints: ({ query }) => ({
    /** Get list of all products */
    listProducts: query<Product[], void>({
      query: () => ({
        url: "billing/products",
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useListProductsQuery } = productApi;
